/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Chyba při registraci`
};

const da_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Fejl ved tilmelding`
};

const de_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Fehler bei der Anmeldung`
};

const en_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Error during registration`
};

const es_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Error durante la suscripción`
};

const fr_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Erreur lors de votre inscription`
};

const hu_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Hiba történt a feliratkozás során`
};

const it_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Errore durante l'iscrizione`
};

const nl_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Fout bij je inschrijving`
};

const pl_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Błąd podczas zapisu`
};

const pt_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Erro durante a sua inscrição`
};

const sv_newsletter_subscription_failure_title = /** @type {(inputs: {}) => string} */ () => {
	return `Fel vid registreringen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_subscription_failure_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_subscription_failure_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_subscription_failure_title", locale)
	if (locale === "cs") return cs_newsletter_subscription_failure_title(inputs)
	if (locale === "da") return da_newsletter_subscription_failure_title(inputs)
	if (locale === "de") return de_newsletter_subscription_failure_title(inputs)
	if (locale === "en") return en_newsletter_subscription_failure_title(inputs)
	if (locale === "es") return es_newsletter_subscription_failure_title(inputs)
	if (locale === "fr") return fr_newsletter_subscription_failure_title(inputs)
	if (locale === "hu") return hu_newsletter_subscription_failure_title(inputs)
	if (locale === "it") return it_newsletter_subscription_failure_title(inputs)
	if (locale === "nl") return nl_newsletter_subscription_failure_title(inputs)
	if (locale === "pl") return pl_newsletter_subscription_failure_title(inputs)
	if (locale === "pt") return pt_newsletter_subscription_failure_title(inputs)
	return sv_newsletter_subscription_failure_title(inputs)
};
export { newsletter_subscription_failure_title as "newsletter.subscription.failure.title" }